import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import { PlaytechGamesData } from "../../../../lib/data/playtech.data";
import GamesSearchModal from "../../../components/GamesSearchModal";
import BottomNav from "../../../../containers/BottomNav";

const PlaytechGames = () => {
  const filteredData = Object.values(
    PlaytechGamesData.PlaytechGamesData.slide1
  );

  return (
    <div>
      <HeaderAfterLogin />
      <main className="main">
        <div className="prvdr-game-page">
          <div className="games-heading">
            <h3>Playtech Games</h3>
            <div className="d-none d-lg-block">
              <GamesSearchModal />
            </div>
          </div>
          <ul className="gamelisting">
            {filteredData.length > 0 ? (
              filteredData.map((game, idx) => (
                <li key={"casinogame" + idx}>
                  <a href={game.href}>
                    <img src={game.imgUrl} alt={game.alt} />
                    <div className="providerName">{game.providerName}</div>
                    <div className="GameName">{game.name}</div>
                  </a>
                </li>
              ))
            ) : (
              <p>No games available for this category.</p>
            )}
          </ul>
        </div>
      </main>

      <BottomNav />
    </div>
  );
};

export default PlaytechGames;
